/**
 * noc-reveal.js
 * IntersectionObserver with 4 states on data-state attribute.
 * States: before → partial → full → past
 *
 * CSS drives all animations — this file is pure state management.
 * Usage: <div data-reveal>...</div>
 *        <div data-reveal="once">...</div>   ← unobserve after first reveal
 *        <div data-reveal data-reveal-delay="200">...</div>
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var THRESHOLDS = [0, 0.15, 0.5, 0.85, 1];
  var ROOT_MARGIN = '-8% 0px -8% 0px';

  function setState(target, ratio, isIntersecting, above) {
    var prev = target.dataset.state;
    var next;

    if (!isIntersecting) {
      next = above ? 'past' : 'before';
    } else if (ratio >= 0.5) {
      next = 'full';
    } else {
      next = 'partial';
    }

    if (next !== prev) {
      target.dataset.state = next;
      /* Apply optional delay only on first reveal */
      if ((next === 'partial' || next === 'full') && !target.dataset.revealed) {
        target.dataset.revealed = '1';
        var delay = parseInt(target.dataset.revealDelay || 0, 10);
        if (delay > 0) {
          target.style.transitionDelay = delay + 'ms';
          target.style.animationDelay  = delay + 'ms';
        }
      }
    }
  }

  function init() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    /* Pre-set all to "before" so there's no flash */
    els.forEach(function (el) {
      if (!el.dataset.state) el.dataset.state = 'before';
    });

    if (reduced) {
      /* Skip animation — show everything immediately */
      els.forEach(function (el) { el.dataset.state = 'full'; });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var t   = entry.target;
        var rect = entry.boundingClientRect;
        var above = rect.top + rect.height < 0;

        setState(t, entry.intersectionRatio, entry.isIntersecting, above);

        if (t.dataset.reveal === 'once' && entry.isIntersecting) {
          io.unobserve(t);
        }
      });
    }, {
      rootMargin: ROOT_MARGIN,
      threshold:  THRESHOLDS
    });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.NocReveal = { init: init };
}());
